import React from 'react';
import BaseSkeleton from './BaseSkeleton';

const SyncSurveyCardSkeleton = () => (
  <div className="bg-white rounded-xl border border-gray-200 p-5 h-full flex flex-col shadow-sm">
    <div className="flex-1 space-y-3 mb-4">
      <BaseSkeleton className="h-6 w-3/4 rounded-md" />
      <BaseSkeleton className="h-4 w-full rounded-md" />
      <BaseSkeleton className="h-4 w-4/5 rounded-md" />
    </div>

    <div className="flex items-center gap-4 mb-4">
      <div className="flex items-center gap-2">
        <BaseSkeleton className="h-3 w-12 rounded-sm" />
        <BaseSkeleton className="h-4 w-4 rounded-full" />
      </div>
      <div className="flex items-center gap-2">
        <BaseSkeleton className="h-3 w-10 rounded-sm" />
        <BaseSkeleton className="h-4 w-6 rounded-sm" />
      </div>
    </div>

    <div className="grid grid-cols-2 gap-3">
      <BaseSkeleton className="h-11 w-full rounded-lg" />
      <BaseSkeleton className="h-11 w-full rounded-lg" />
    </div>
  </div>
);

const SyncPageSkeleton = () => {
  return (
    <div className="p-2 h-full">
      <div className="grid grid-cols-1 gap-6">
        {[...Array(4)].map((_, index) => (
          <SyncSurveyCardSkeleton key={index} />
        ))}
      </div>
    </div>
  );
};

export default SyncPageSkeleton;